/**
 * Settings Service
 * 사용자 설정, 프로필, 데이터 관리 관련 모든 API 호출을 중앙화
 */

import { apiClient } from './apiClient';

class SettingsService {
  /**
   * 사용자 환경설정 조회
   * @returns {Promise<object>} 환경설정 데이터 (currency, language, notifications, emailReports, theme)
   */
  async getPreferences() {
    return apiClient.get('/api/user/preferences');
  }

  /**
   * 사용자 환경설정 업데이트
   * @param {object} data - 업데이트할 환경설정 데이터
   * @param {string} [data.currency] - 통화 설정
   * @param {string} [data.language] - 언어 설정
   * @param {boolean} [data.notifications] - 알림 설정
   * @param {boolean} [data.emailReports] - 이메일 리포트 설정
   * @param {string} [data.theme] - 테마 설정
   * @returns {Promise<void>}
   */
  async updatePreferences(data) {
    return apiClient.put('/api/user/preferences', data);
  }

  /**
   * 사용자 프로필 업데이트 (닉네임, 이메일, 비밀번호 변경)
   * @param {object} data - 프로필 업데이트 데이터
   * @param {string} [data.nickname] - 닉네임
   * @param {string} [data.email] - 이메일
   * @param {string} [data.currentPassword] - 현재 비밀번호 (비밀번호 변경 시)
   * @param {string} [data.newPassword] - 새 비밀번호 (비밀번호 변경 시)
   * @returns {Promise<{user: object}>} 업데이트된 사용자 정보
   */
  async updateProfile(data) {
    return apiClient.put('/api/user/profile', data);
  }

  /**
   * 데이터 내보내기 (JSON 파일 다운로드)
   * @returns {Promise<Blob>} 내보내기 데이터 (blob)
   */
  async exportData() {
    return apiClient.get('/api/export/data', { responseType: 'blob' });
  }

  /**
   * 계정 삭제
   * @param {string} password - 계정 삭제 확인용 비밀번호
   * @returns {Promise<void>}
   */
  async deleteAccount(password) {
    return apiClient.delete('/api/user/account', { data: { password } });
  }
}

export const settingsService = new SettingsService();
export default settingsService;
